import React, { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import dustbin from "../../images/dustbin.png";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import BillPreview from "../reusableComponents/BillPreview";
import { useDispatch } from "react-redux";
import {
  createQuoteBill,
  createSaleLedger,
  mutateItems,
  updateQuotation,
} from "./httpCalls";
import { toast } from "react-toastify";
import { clearInventory } from "../inventory/itemsSlice";
import { getBillNumber } from "../point of sale/httpCalls";
import { BoxesPacking } from "../features/BoxesPacking";

function QuotationDetail(props) {
  const { date, quotation } = props.location.state;
  const dispatch = useDispatch();
  const history = useHistory();
  let companyCode = localStorage.getItem("companyCode");

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [newPaid, setNewPaid] = useState(0);
  const [quotations, setQuotations] = useState({});
  const [modal, setModal] = useState(false);
  const [bill, setBill] = useState("");
  const [billNumber, setbillNumber] = useState(0);

  useEffect(() => {
    setQuotations(quotation);
    setItems(quotation.items);
    getBill();
  }, []);

  const getBill = async () => {
    let data = await getBillNumber();
    setbillNumber(data);
  };

  const totalPrice = () => {
    let total = 0;
    let billDiscount = 0;
    items.map((item) => {
      let saleQty = item.saleQuantity ? item?.saleQuantity : 1;
      let itemPrice = item.salePrice ? item?.salePrice : item.price;
      let totalPrice = parseInt(itemPrice * saleQty);
      let totalDiscount;
      let itemDiscount = item.saleDiscount
        ? parseInt(item.saleDiscount)
        : item.saleDiscount == ""
        ? parseInt(item.saleDiscount)
        : parseInt(item.discount);
      if (itemDiscount) {
        let eachValue = (itemDiscount / 100) * totalPrice;
        totalDiscount = eachValue;
      } else {
        totalDiscount = 0;
      }

      total =
        parseFloat(total) +
        parseFloat(saleQty) * parseFloat(itemPrice) -
        totalDiscount;
    });
    if (quotation.discounts) {
      if (
        quotation.discount_Type == "price" ||
        quotation.discount_type == "price" ||
        quotation.discountType == "price"
      ) {
        billDiscount = parseInt(quotation.discounts);
      } else {
        let first = total / 100;
        let second = quotation.discounts;
        let temps = parseInt(first * second);
        billDiscount = temps;
      }
    }
    return { Total: total, subTotal: parseInt(total - billDiscount) };
  };

  const removeItem = (index) => {
    let copyItems = JSON.parse(JSON.stringify(items));
    copyItems.splice(index, 1);
    setItems(copyItems);
  };
  const createBill = () => {
    setLoading(true);
    let saveSale = [];
    let updatedItems = [];
    let billItems = [];
    const copyItems = JSON.parse(JSON.stringify(items));
    copyItems.forEach((item) => {
      let boxes = 0;
      if (BoxesPacking()) {
        if (item.saleQuantity && item?.packing) {
          boxes = parseFloat(item.saleQuantity) / item.packing;
        } else {
          boxes = 0;
        }
      }
      let saleQty = item.saleQuantity ? item?.saleQuantity : 1;
      let itemPrice = item.salePrice ? item?.salePrice : item.price;

      let sale = {
        timestamp: Math.floor(Date.now() / 1000),
        read: "false",
        date: quotations.created_at,
        company_code: localStorage.getItem("companyCode"),
        imgURL: item.imgURL,
        minQuantity: item.minquantity,
        quantity: saleQty,
        description: item.description,
        itemId: item.itemId,
        name: item.name,
        totalPrice: parseInt(itemPrice) * parseInt(saleQty),
        totalProfit:
          parseInt(item.price) * parseInt(saleQty) -
          parseInt(item.costPrice, 10) * parseInt(saleQty),
        price: parseInt(item.costPrice, 10),
        salePrice: itemPrice,
        itemCode: item.itemCode,
        vendor: item.vendor,
        dateOfPurchase: item.dateOfPurchase,
      };
      saveSale.push(sale);
      let updateItem = {
        ...item,
        company_code: companyCode,
      };
      if (item.weightType) {
        updateItem.weight = parseFloat(item.weight - saleQty);
      } else {
        updateItem.quantity = parseFloat(item.quantity - saleQty);
      }

      billItems.push(
        JSON.parse(
          JSON.stringify({
            ...updateItem,
            saleQuantity: saleQty,
            salePrice: itemPrice,
          })
        )
      );
      delete updateItem.saleQuantity;
      delete updateItem.salePrice;
      if (boxes) {
        let newItem = {
          _id: item._id,
          saleQuantity: saleQty,
          boxes: boxes,
        };
        updatedItems.push(newItem);
      } else {
        let newItem = {
          _id: item._id,
          saleQuantity: saleQty,
        };
        updatedItems.push(newItem);
      }
    });
    let id = uuidv4();
    let _id = id.replaceAll("-", "");
    let bill = {
      _id: _id,
      quotations: quotations,
      date: date,
      subTotal: totalPrice().subTotal,
      total: totalPrice().Total,
      billNumber: billNumber,
      change: newPaid - totalPrice().Total,
      paid: parseInt(newPaid),
    };
    let ledger = {
      _id: quotations.ledger_id,
      srNum: uuidv4(),
      date: +new Date(),
      detail: `Item Sale ${billNumber}`,
      billNumber: billNumber,
      totalAmount: totalPrice().Total,
      depositedAmount: newPaid,
      remainingAmount: totalPrice().Total - newPaid,
    };
    let Quote = {
      ...quotations,
      items: items,
      new_paid: newPaid,
      paid: parseInt(quotations.paid) + parseInt(newPaid),
      discounts: quotations.discounts,
      change: Math.abs(newPaid - totalPrice().Total),
      customerName: quotations.customerName,
      date: +new Date(),
      makeInvoice: true,
    };
    console.log('bill', bill)
    Promise.all([
      createQuoteBill(bill),
      mutateItems(updatedItems),
      updateQuotation(Quote),
      createSaleLedger(ledger),
    ])
      .then((values) => {
        console.log(values);
      })
      .catch((err) => {
        console.log(err);
        toast.configure();
        toast.error("Error");
      });

    setLoading(false);
    dispatch(clearInventory());
    history.push("/inventory/admin/quotations");
  };

  const handleBill = () => {
    let obj = {
      billNumber: billNumber,
      customer: quotations?.customerName
        ? quotations.customerName
        : quotations.customer,
      items: quotations?.items,
      discount: quotations.discounts,
      discount_type: quotations.discount_type
        ? quotations.discount_type
        : quotations.discountType,
      discount_text: quotations?.discount_text,
      created_at: quotations?.created_at,
      date: quotations?.date,
      subTotal: totalPrice().subTotal,
      total: totalPrice().Total,
      paid: parseInt(quotations.paid + newPaid),
      outstandingBalance: quotations?.outstandingBalance,
      change: parseInt(totalPrice().Total - newPaid),
      formallyOutstandings: quotations?.formallyOutstandings,
      notes: quotations?.notes,
    };
    setBill(obj);
  };

  const toggle = () => {
    setModal((prevState) => !prevState);
  };

  const clickHandler = () => {
    handleBill();
    toggle();
  };
  const handleChange = (e, index) => {
    let name = e.target.name;
    let value = e.target.value;
    let copyItems = JSON.parse(JSON.stringify(items));
    copyItems[index][name] = value;
    setItems(copyItems);
  };

  return (
    <div>
      <div className="sale-grid" id="Table">
        <div  className="table-container">
          <div className="table-titles-quotation">
            <h2 className="center regular f-16">#</h2>
            <h2 className="regular f-16">Item</h2>
            <h2 className="regular f-16">Dics</h2>
            <h2 className="regular f-16">Qty</h2>
            <h2 className="regular f-16">Unit Price</h2>
            <h2 className="regular f-16">Price</h2>
            <h2 className="regular f-16">Act</h2>
          </div>
          {items &&
            items.map((item, index) => {
              let saleQty = item.saleQuantity ? item?.saleQuantity : 1;
              let itemPrice = item.salePrice ? item?.salePrice : item.price;
              let finalPrice = parseInt(itemPrice * saleQty);

              let itemDiscount = item.saleDiscount
                ? item.saleDiscount
                : item.saleDiscount == ""
                ? item.saleDiscount
                : item.discount;
              if (itemDiscount) {
                let eachValue = (itemDiscount / 100) * finalPrice;
                item.discountAmount = eachValue;
              } else if (itemDiscount == "") {
                item.discountAmount = 0;
              } else {
                item.discountAmount = 0;
              }

              return (
                <div key={index} className="table-values-quotation">
                  <h3 className="center regular f-16">{index + 1}</h3>

                  <h3 className="regular f-16">{item.name}</h3>
                  <h3 className="regular f-16">
                    {item.saleDiscount ? item.saleDiscount : item.discount}
                  </h3>
                  <input
                    className="input-sale f-16 "
                    type="number"
                    max={item.quantity}
                    min="0"
                    name="saleQuantity"
                    value={saleQty}
                    onChange={(e) => handleChange(e, index)}
                  />

                  <input
                    className="input-sale f-16 "
                    type="number"
                    name="salePrice"
                    value={itemPrice}
                    onChange={(e) => handleChange(e, index)}
                  />
                  <h3 className="regular f-16 margin-class">
                    {itemPrice * saleQty - item.discountAmount}
                  </h3>
                  {quotations.makeInvoice != true && (
                    <img
                      className="dustbin-second margin-class"
                      src={dustbin}
                      alt="img"
                      onClick={() => removeItem(index)}
                    ></img>
                  )}
                </div>
              );
            })}
        </div>
        <div className="total-container" id="table">
          <div className="finances-flex">
            <h3>Sub Total:</h3>
            <h3 className="prices regular">{totalPrice().subTotal}</h3>
          </div>

          <hr></hr>
          <div className="finances-flex">
            <h3>Discounts:</h3>
            <h3 className="prices regular">
              {quotation.discounts ? quotation.discounts : 0}{" "}
              {quotation.discount_type == "percentage" ? "%" : "Rps"}
            </h3>
          </div>

          <hr></hr>
          <div className="finances-flex">
            <h3>Total:</h3>
            <h3 className="prices">{totalPrice().Total}</h3>
          </div>
          <hr></hr>
          <div className="finances-flex">
            <h3>Paid:</h3>
            <h3 className="prices regular">{quotations.paid}</h3>
          </div>
          <hr></hr>
          <div className="finances-flex">
            <h3>Remaining:</h3>
            <h3 className="prices regular">
              {totalPrice().Total - quotations.paid}
            </h3>
          </div>
          <hr></hr>
          {items != "" && (
            <>
              {quotations.makeInvoice != true && (
                <>
                  <div className="finances-flex">
                    <div>
                      <h3>ADD AMOUNT:</h3>
                      <div className="flex ">
                        <h3>Rs</h3>
                        <input
                          className="input-paid prices regular"
                          type="number"
                          min="0"
                          value={newPaid}
                          onChange={(e) => setNewPaid(e.target.value)}
                        />
                      </div>
                    </div>
                    <hr className="hrule"></hr>
                    <div>
                      <h3>CHANGE:</h3>
                      <div className="flex no-mg">
                        <h3 className="prices regular">
                          Rs: {parseInt(newPaid) - totalPrice().Total}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <hr />
                </>
              )}

              <div className="finances-flex">
                <h3>Customer: </h3>

                <h3 className="prices regular">{quotations.customerName}</h3>
              </div>

              {quotations.makeInvoice != true && (
                <div style={{ textAlign: "center" }}>
                  {loading == true && (
                    <ClipLoader size={50} color="#4DAF51" loading={loading} />
                  )}
                  {loading == false && (
                    <button className="print-btn" onClick={clickHandler}>
                      Make Invoice
                    </button>
                  )}
                </div>
              )}

              {quotations.makeInvoice == true && (
                <div style={{ textAlign: "center" }}>
                  <button className="print-btn">Invoice is made</button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="centralize-loader">
        <ClipLoader size={150} color="#4DAF51" loading={loading} />
      </div>

      <BillPreview
        title="Bill Preview"
        open={modal}
        onSale={createBill}
        onClose={toggle}
        onClickCancel={toggle}
        bill={bill}
        sellItem={true}
      />
    </div>
  );
}

export default QuotationDetail;
